import type * as lazyIndex from './lazyIndex';
import { LazyAction, LazyModule, LazyImport } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "TabViewStore" */ './lazyIndex'),
    { name: 'TabViewStore' }
);

export const lazyActivateTab: LazyAction<typeof lazyIndex.activateTab, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.activateTab);
export const lazyAddTab: LazyAction<typeof lazyIndex.addTab, typeof lazyModule> = new LazyAction(
    lazyModule,
    m => m.addTab
);
export const lazyCloseTab: LazyAction<typeof lazyIndex.closeTab, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.closeTab);
export const lazySetTabIsShown: LazyAction<typeof lazyIndex.setTabIsShown, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.setTabIsShown);
export const lazySetBlink: LazyAction<typeof lazyIndex.setBlink, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.setBlink);
export const lazyReloadSecondaryTabAsDeeplink: LazyAction<
    typeof lazyIndex.reloadSecondaryTabAsDeeplink,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.reloadSecondaryTabAsDeeplink);
export const lazyRemoveTabViewState: LazyAction<
    typeof lazyIndex.removeTabViewState,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.removeTabViewState);

export const lazyGetTabById: LazyImport<typeof lazyIndex.getTabById, typeof lazyModule> =
    new LazyImport(lazyModule, m => m.getTabById);

export type { default as SecondaryReadingPaneTabData } from './store/schema/SecondaryReadingPaneTabData';
export { getStore, primaryTab } from './store/tabStore';
export { default as addFullOptionsTab } from './utils/addFullOptionsTab';
export { default as getActiveContentTab } from './utils/getActiveContentTab';
export { default as getActiveSecondaryReadingPaneTabItemId } from './utils/getActiveSecondaryReadingPaneTabItemId';
export { default as findTabByData } from './utils/findTabByData';
export { default as findTabIdBySxSId } from './utils/findTabIdBySxSId';
export {
    default as secondaryTabsHaveId,
    otherSecondaryTabsRepresentSameItem,
} from './utils/secondaryTabsHaveId';
export { default as getTabTitle } from './utils/getTabTitle';
export { TabType, TabState } from './store/schema/TabViewState';
export type {
    default as TabViewState,
    SecondaryReadingPaneTabViewState,
    MailComposeTabViewState,
    CalendarComposeTabViewState,
    CalendarReadingPaneTabViewState,
    FullOptionTabViewState,
    RemindersTabViewState,
    AddCalendarsTabViewState,
    FileErrorTabViewState,
    DeskBookingComposeTabViewState,
    MetaOsTabViewState,
} from './store/schema/TabViewState';
export { registerTabHandler } from './utils/TabHandler';
export type { default as TabHandler } from './utils/TabHandler';
export { default as getPopoutTabsViewState } from './selectors/getPopoutTabsViewState';
export {
    default as getTabsByTabType,
    getFullOptionsTab,
    getFileErrorTab,
} from './selectors/getTabsByTabType';
